export * from "__react-dom__";
export { default } from "__react-dom__";

type Fiber = {
  stateNode?: unknown;
  child?: Fiber | null;
  sibling?: Fiber | null;
};

function findFirstHostNode(fiber: Fiber | null | undefined): Element | null {
  if (!fiber) return null;
  if (fiber.stateNode instanceof Element) return fiber.stateNode;
  let child = fiber.child;
  while (child) {
    const node = findFirstHostNode(child);
    if (node) return node;
    child = child.sibling ?? null;
  }
  return null;
}

export function findDOMNode(instance: unknown): Element | null {
  if (!instance) return null;
  if (instance instanceof Element) return instance;
  const holder = instance as {
    _reactInternals?: Fiber;
    _reactInternalFiber?: Fiber;
  };
  return findFirstHostNode(
    holder._reactInternals ?? holder._reactInternalFiber,
  );
}
